<template>
  <div class="flex flex-col gap-4 p-4">
    <!-- Billing Address -->
    <FormCard title="Billing Address">
      <AddressEditor v-model="billingAddress" prefix="billing" />
    </FormCard>

    <!-- Service Address -->
    <FormCard title="Service Address">
      <AddressEditor
        v-model="serviceAddress"
        prefix="service"
        show-location-name
      />
    </FormCard>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { EventBus } from "@/lib/event_bus";

import type { EditableAddress } from "@/components/QuoteInvoice/AddressEditor.vue";
import AddressEditor from "@/components/QuoteInvoice/AddressEditor.vue";
import FormCard from "@/components/Seranova/FormCard/FormCard.vue";
import type { Quote } from "@/typings/quote";

const props = defineProps<{
  quote: Quote;
}>();

const store = useStore();

const serviceAddress = ref<EditableAddress>({
  name: props.quote.service_address?.name || "",
  street: props.quote.service_address?.street || "",
  unit: props.quote.service_address?.unit || "",
  city: props.quote.service_address?.city || "",
  state: props.quote.service_address?.state || "",
  zip_code: props.quote.service_address?.zip_code || ""
});

const billingAddress = ref<EditableAddress>({
  street: props.quote.billing_address?.street || "",
  unit: props.quote.billing_address?.unit || "",
  city: props.quote.billing_address?.city || "",
  state: props.quote.billing_address?.state || "",
  zip_code: props.quote.billing_address?.zip_code || ""
});

const save = async () => {
  const link = props.quote.links?.update_details;
  if (!link) return;

  await store.dispatch("updateQuoteDetails", {
    link,
    data: {
      service_address_name: serviceAddress.value.name,
      service_address_street: serviceAddress.value.street,
      service_address_unit: serviceAddress.value.unit,
      service_address_city: serviceAddress.value.city,
      service_address_state: serviceAddress.value.state,
      service_address_zip_code: serviceAddress.value.zip_code,
      billing_address_street: billingAddress.value.street,
      billing_address_unit: billingAddress.value.unit,
      billing_address_city: billingAddress.value.city,
      billing_address_state: billingAddress.value.state,
      billing_address_zip_code: billingAddress.value.zip_code
    }
  });

  EventBus.$emit("refresh-quote-datatable");
};

defineExpose({ save });
</script>
